module.exports = __webpack_public_path__ + "static/img/download_logo.fa4415c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_logo.png
// module id = zaiA
// module chunks = 1